import { gql } from 'graphql-tag'

export const SUBMIT_CONSUMER_MOBILE_APP_FEEDBACK = gql`
  mutation submitConsumerMobileAppFeedback($customerId: String!, $feedback: String!, $deviceId: String!) {
    submitConsumerMobileAppFeedback(customerId: $customerId, feedback: $feedback, deviceId: $deviceId) {
      messageId
      customerId
      feedback
      deviceId
    }
  }
`
